import { memo, forwardRef } from 'react';
import { clsx } from 'clsx';
import type { Brand } from '@apiTypes';
import BrandImage from '../BrandImage';
import CurrentStoreLink from '../../../core/components/router/CurrentStoreLink';
import styles from './BrandItem.module.scss';

interface BrandItemProps {
    brand: Brand;
    onBrandSelect?: () => void;
    division?: boolean;
}

const BrandItem = ({
    brand: { logo, name, slug, customLogo },
    onBrandSelect,
    division,
}: BrandItemProps) => {
    return (
        <CurrentStoreLink
            to={`brand/${slug}`}
            className={clsx(styles.card, {
                [styles.division]: division,
            })}
            onClick={onBrandSelect}
        >
            <div className={styles.imageContainer}>
                <div className={styles.image}>
                    {customLogo ? (
                        <img
                            src={customLogo}
                            alt={name}
                            className={clsx(styles.customLogoImage)}
                        />
                    ) : (
                        <BrandImage
                            url={customLogo ?? logo}
                            renditionSize="232px"
                            alt={name}
                        />
                    )}
                </div>
            </div>
            <div className={styles.name}>{name}</div>
        </CurrentStoreLink>
    );
};
export default memo(forwardRef(BrandItem));
